import { isIncreasedFlexibilityEnabled } from 'feature-flags';
import { useLayoutIds } from 'view/layout-next/controllers';

export interface UseApplySectionBackgroundProps {
    sectionId: string;
}

export const useApplySectionBackground = function ({ sectionId }: UseApplySectionBackgroundProps) {
    const [{ HelpLayoutHeroElement, HelpLayoutAnnouncementElement }] = useLayoutIds();
    const allowedSectionBackground = [HelpLayoutHeroElement.sectionId, HelpLayoutAnnouncementElement.sectionId];

    if (isIncreasedFlexibilityEnabled()) {
        // allowed for all
        return true;
    }
    return allowedSectionBackground.includes(sectionId);
};
